import { render, staticRenderFns } from "./ParametrosPesquisa.vue?vue&type=template&id=b12918ba&"
import script from "./ParametrosPesquisa.vue?vue&type=script&lang=js&"
export * from "./ParametrosPesquisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports